// components/Toaster.tsx
"use client";
import { StatusTypeEnum } from "@/interfaces/status";
import React from "react";

import { useToasterStore } from "../../../store/useToasterStore";

const Toaster: React.FC = () => {
  const { isVisible, message, status } = useToasterStore();

  if (!isVisible) {
    return null;
  }

  let backgroundColor = "bg-blue-500";
  if (status === StatusTypeEnum.SUCCESS) {
    backgroundColor = "bg-green-500";
  }
  if (status === StatusTypeEnum.FAILED) {
    backgroundColor = "bg-red-500";
  }

  return (
    <div className={`fixed bottom-5 left-5 rounded-lg px-6 py-4 text-white shadow-lg ${backgroundColor}`}>
      {message}
    </div>
  );
};

export default Toaster;
